/* AUVENNE V3 deep-audit fixes: old catalogue, PDP and cart drawer. */
(function(){
  'use strict';
  if(window.AUVENNEV3OldProductPolishBound)return;
  window.AUVENNEV3OldProductPolishBound=true;

  var isSv=(document.documentElement.lang||'').toLowerCase().indexOf('sv')===0;
  function ui(nl,sv){return isSv?sv:nl;}
  function rootPath(){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r.charAt(r.length-1)==='/'?r:r+'/';}

  /* These are the actual launch products on Homepage V3. Age alone must not create a Nieuw badge. */
  var newHandles=new Set([
    'legame-knooparmband','linea-open-ring','luce-parel-oorbellen','ovale-fijne-schakelarmband',
    'abbraccio-knuffelring','initiale-ring','nodo-parel-oorbellen','insieme-ring-set',
    'perla-huggie-hoops','fortuna-clover-necklace','cascata-beaded-y-necklace','promessa-oval-ring',
    'legame-knot-cuff','mira-beaded-ring'
  ]);

  function drawerRender(data,trigger){
    var api=window.AUVENNECartDrawer;
    if(api&&typeof api.render==='function')return Promise.resolve(api.render(data,trigger));
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&data&&data.sections&&data.sections['cart-drawer']&&typeof drawer.renderContents==='function'){
      try{drawer.renderContents(data);}catch(_){ }
    }
    if(drawer&&typeof drawer.open==='function')drawer.open(trigger);
    return Promise.resolve();
  }

  async function ajaxProductForm(form,event){
    if(event){event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();}
    if(!form||form.dataset.auvOldPdpAdding==='1')return;
    if(!form.reportValidity())return;
    var button=form.querySelector('[data-lu-add],button[name="add"],button[type="submit"]');
    if(!button||button.disabled)return;
    var idField=form.querySelector('[data-lu-varid],input[name="id"]');
    if(!idField||!String(idField.value||'').trim())return;

    form.dataset.auvOldPdpAdding='1';
    var original=button.textContent;
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent=ui('TOEVOEGEN…','LÄGGER TILL…');
    try{
      var body=new FormData(form);
      body.set('id',idField.value);
      var bundle=form.querySelector('[data-legame-bundle]');
      if(bundle && bundle.querySelector('[name="legame_quantity"]:checked')?.value==='2'){
        var second=bundle.querySelector('[data-legame-second]');
        if(!second || !second.value || second.selectedOptions[0]?.disabled)throw new Error(ui('Kies een kleur voor beide armbanden.','Välj färg för båda armbanden.'));
        body.delete('id');body.delete('quantity');
        body.set('items[0][id]',idField.value);
        body.set('items[0][quantity]',second.value===idField.value?'2':'1');
        if(second.value!==idField.value){body.set('items[1][id]',second.value);body.set('items[1][quantity]','1');}
      }
      body.set('sections','cart-drawer,cart-icon-bubble');
      body.set('sections_url',location.pathname+location.search);
      var res=await fetch(rootPath()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:body});
      var data=await res.json();
      if(!res.ok||data.status||data.errors)throw new Error(data.description||data.message||ui('Toevoegen is niet gelukt.','Det gick inte att lägga till.'));
      button.textContent=ui('TOEGEVOEGD ✓','TILLAGT ✓');
      await drawerRender(data,button);
      window.setTimeout(function(){
        if(!button.isConnected)return;
        button.disabled=false;
        button.removeAttribute('aria-busy');
        button.textContent=original;
        delete form.dataset.auvOldPdpAdding;
      },900);
    }catch(error){
      delete form.dataset.auvOldPdpAdding;
      button.disabled=false;
      button.removeAttribute('aria-busy');
      button.textContent=original;
      var msg=form.querySelector('[data-legame-status],[data-auv-picker-status],[data-auv-card-status],[data-cro-status]');
      if(msg){msg.textContent=error&&error.message?error.message:ui('Toevoegen is niet gelukt.','Det gick inte att lägga till.');msg.dataset.tone='bad';}
    }
  }

  function compactVariantText(value){
    var text=String(value||'');
    if(isSv){
      text=text.replace(/Gold tone|Gold Tone|Gold Color|Goudkleur|Guldfärgad/gi,'Guld');
      text=text.replace(/Silver tone|Silver Tone|Silver Color|Zilverkleur|Silverfärgad/gi,'Silver');
      text=text.replace(/Rose Gold|Rose gold|Roségoudkleur|Roséguld/gi,'Roséguld');
      text=text.replace(/\s*\/\s*(One Size|Eén maat|En storlek)/gi,'');
    }else{
      text=text.replace(/Gold tone|Gold Tone|Gold Color|Goudkleur/gi,'Goud');
      text=text.replace(/Silver tone|Silver Tone|Silver Color|Zilverkleur/gi,'Zilver');
      text=text.replace(/Rose Gold|Rose gold|Roségoudkleur/gi,'Roségoud');
      text=text.replace(/\s*\/\s*(One Size|Eén maat)/gi,'');
    }
    return text.replace(/\s{2,}/g,' ').trim();
  }

  function cleanCard(card){
    if(!card)return;
    card.querySelectorAll('[data-cro-card-swatch-label],.cro-card__single-colour,.cro-card__variant-note,.cro-card__colour,.cro-card__colours').forEach(function(node){
      node.hidden=true;
      node.setAttribute('aria-hidden','true');
    });

    /* Only Homepage V3 launch products may carry the ordinary Nieuw badge. */
    var handle=card.getAttribute('data-product-handle')||'';
    if(!newHandles.has(handle)){
      card.querySelectorAll('.cro-card__badge').forEach(function(badge){
        var value=(badge.textContent||'').trim().toLowerCase();
        if(value==='nieuw'||value==='nytt'||value==='nyhet')badge.remove();
      });
    }
  }

  function bindCollectionForm(form){
    if(!form||form.dataset.auvOldCollectionBound==='1')return;
    form.dataset.auvOldCollectionBound='1';
    form.addEventListener('submit',function(event){ajaxProductForm(form,event);},true);
  }

  function makeDelivery(){
    var delivery=document.createElement('auvenne-delivery-estimate');
    delivery.className='auv-delivery-estimate auv-drawer__delivery';
    delivery.setAttribute('data-auv-drawer-final-delivery','');
    delivery.dataset.minDays='2';
    delivery.dataset.maxDays='5';
    delivery.dataset.locale=isSv?'sv':'nl';
    delivery.dataset.connector=isSv?' till ':' t/m ';
    var icon=document.createElement('span');
    icon.className='auv-delivery-estimate__icon';
    icon.setAttribute('aria-hidden','true');
    icon.textContent='✓';
    var copy=document.createElement('span');
    var strong=document.createElement('strong');
    strong.textContent=ui('Verwachte bezorging','Förväntad leverans');
    var output=document.createElement('span');
    output.setAttribute('data-auv-delivery-output','');
    output.textContent=ui('2–5 werkdagen','2–5 arbetsdagar');
    copy.append(strong,output);
    delivery.append(icon,copy);
    return delivery;
  }

  function makeTrust(){
    var trust=document.createElement('div');
    trust.className='auv-drawer__trust';
    trust.setAttribute('data-auv-drawer-final-trust','');
    var returns=document.createElement('span');
    returns.textContent=ui('✓ 30 dagen retour · 60 dagen voor geschikte MY AUVENNE-aankopen','✓ 30 dagars retur · 60 dagar för berättigade MY AUVENNE-köp');
    var secure=document.createElement('span');
    secure.textContent=ui('✓ Veilig betalen','✓ Säker betalning');
    trust.append(returns,secure);
    return trust;
  }

  function patchCartDetails(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return;
    var heading=drawer.querySelector('.drawer__heading');
    if(heading)heading.textContent=ui('Jouw winkelmand','Din varukorg');

    /* No supplier-ish option copy in cart or recommendations. */
    drawer.querySelectorAll('.product-option dd,.auv-third__variant').forEach(function(node){
      var next=compactVariantText(node.textContent);
      if(next&&next!==node.textContent.trim())node.textContent=next;
    });

    var benefits=drawer.querySelector('.auv-drawer__benefits');
    if(!benefits)return;
    if(!benefits.querySelector('[data-auv-drawer-final-delivery]'))benefits.appendChild(makeDelivery());
    if(!benefits.querySelector('[data-auv-drawer-final-trust]'))benefits.appendChild(makeTrust());
  }

  function bind(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    root.querySelectorAll('[data-cro-card]').forEach(cleanCard);
    root.querySelectorAll('.cro-card form[action*="/cart/add"]').forEach(bindCollectionForm);
    var pdp=(root.matches&&root.matches('#lu-product-form'))?root:root.querySelector('#lu-product-form');
    if(pdp&&!pdp.dataset.auvOldPdpBound){
      pdp.dataset.auvOldPdpBound='1';
      pdp.addEventListener('submit',function(event){ajaxProductForm(pdp,event);},true);
    }
    patchCartDetails();
  }

  function cartHref(anchor){
    if(!anchor||!anchor.href)return false;
    try{
      var url=new URL(anchor.href,location.href);
      return url.origin===location.origin&&url.pathname.replace(/\/$/,'')===(rootPath()+'cart').replace(/\/$/,'');
    }catch(e){return false;}
  }

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form||!form.matches)return;
    if(form.matches('#lu-product-form,.cro-card form[data-cro-add-form]'))ajaxProductForm(form,event);
  },true);

  document.addEventListener('click',function(event){
    var add=event.target.closest&&event.target.closest('#lu-product-form [data-lu-add],#lu-product-form button[name="add"],[data-lu-sticky-add]');
    if(add){
      var form=document.getElementById(add.getAttribute('form')||'lu-product-form')||add.closest('form');
      if(form){ajaxProductForm(form,event);return;}
    }
    var cartLink=event.target.closest&&event.target.closest('a[href]');
    if(cartHref(cartLink)){
      var drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.open==='function'){
        event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();drawer.open(cartLink);
      }
    }
  },true);

  document.addEventListener('auvenne:cart-synced',function(){window.requestAnimationFrame(patchCartDetails);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bind(document);},{once:true});else bind(document);
  document.addEventListener('shopify:section:load',function(event){bind(event.target||document);});
  new MutationObserver(function(mutations){
    if(mutations.some(function(m){return m.addedNodes&&m.addedNodes.length;}))window.requestAnimationFrame(function(){bind(document);});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
